// extracted by mini-css-extract-plugin
export default {"navText":"NavigationBarLinkComponent_navText__NiwON","activeTab":"NavigationBarLinkComponent_activeTab__qdmoE"};